import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import TimerComponent from 'src/hook-form/timer-input';

interface Props {
  rules?: any;
  name: string;
  label: string;
  required?: boolean;
  defaultValue?: string;
  helper?: string;
  items: {value: string; label: string}[];
}

const HookFormTimerInput = (props: Props) => {
  const {control} = useFormContext();

  return (
    <Controller
      control={control}
      rules={props.rules}
      render={({field}) => <TimerComponent {...props} {...field} />}
      name={props.name}
      defaultValue={props.defaultValue}
    />
  );
};

export default HookFormTimerInput;
